export const setTitle = (routeName, isSuperUser = false) => {
  let title = 'S&P Global Energy Subscription Manager';

  const getCaseMatch = (caseValue) => {
    if (routeName.includes(caseValue)) return routeName;
    else return caseValue;
  };
  switch (routeName) {
    case '/user-location':
    case '/export-users':
      title = 'User & Location | S&P Global Energy Subscription Manager';
      break;
    case '/user-group':
      title = 'My Groups | S&P Global Energy Subscription Manager';
      break;
    case '/entitlements':
    case '/entitlements-serverside':
    case '/delete-entitlements':
    case '/add-entitlements':
    case '/product-entitlements':
    case '/export-entitlements':
      title = 'Entitlements | S&P Global Energy Subscription Manager';
      break;
    case getCaseMatch('/packages'):
      title = 'Package & Delivery | S&P Global Energy Subscription Manager';
      break;
    case '/user-dashboard':
      title = 'User Profile | S&P Global Energy Subscription Manager';
      break;
    case '/change-history':
      title = 'Change History | S&P Global Energy Subscription Manager';
      break;
    case '/email-domain-contract-settings':
      title = isSuperUser
        ? 'Contract Actions, Manage Email Domain & Deactivation Governance | S&P Global Energy Subscription Manager'
        : 'Contract Actions & Manage Email Domain | S&P Global Energy Subscription Manager';
      break;
    // case '/manage-email-domains':
    //   title = 'Manage Email Domains | S&P Global Energy Subscription Manager';
    //   break;
    case '/admin-dashboard':
      title = 'Home | S&P Global Energy Subscription Manager';
      break;
    case '/my-subscription':
      title = 'My Subscription | S&P Global Energy Subscription Manager';
      break;
    case '/user-info':
      title = 'User Profile | S&P Global Energy Subscription Manager';
      break;
    case '/onboard-contracts':
      title = 'Onboard Contracts | S&P Global Energy Subscription Manager';
      break;
    case '/reports':
      title =
        'Active User Entitlements Export | S&P Global Energy Subscription Manager';
      break;
    default:
      title = 'S&P Global Energy Subscription Manager';
      break;
  }
  document.title = title;
};
